module.exports = __webpack_public_path__ + "media/src/images/partners/tpu-211b9ae1c6a68607b69e4a452f5e2280.jpg";